import { render, staticRenderFns } from "./ReferenceMatrixList.vue?vue&type=template&id=144b0f24&"
import script from "./ReferenceMatrixList.vue?vue&type=script&lang=js&"
export * from "./ReferenceMatrixList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports